import { Link } from "wouter";
import { AnchorMark } from "@/components/marks";

export function Footer() {
  return (
    <footer className="bg-[#C06B5D] text-[#ECE9E0] pt-24 pb-12 px-6 md:px-12">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-start gap-16 mb-20">
        <div className="md:w-1/3">
          <AnchorMark className="w-64 mb-8 text-[#ECE9E0]" />
          <p className="tracking-widest uppercase text-[10px] leading-loose opacity-80 max-w-xs">
            Situated at the convergence of five elemental forces. Transforming
            an underutilized natural asset into California's premier geothermal
            leisure club.
          </p>
        </div>
        <div className="flex flex-col md:flex-row gap-12 md:gap-32">
          <div className="flex flex-col space-y-6 text-xs tracking-[0.3em] font-bold uppercase">
            <Link href="/" className="text-left hover:text-[#1D4C74] transition-colors">
              The Vision
            </Link>
            <Link href="/gallery" className="text-left hover:text-[#1D4C74] transition-colors">
              The Compound
            </Link>
            <Link href="/article" className="text-left hover:text-[#1D4C74] transition-colors">
              The Almanac
            </Link>
          </div>
          <div className="flex flex-col space-y-6 text-xs tracking-[0.3em] font-bold uppercase">
            <Link href="/dispatch" className="text-left hover:text-[#1D4C74] transition-colors">
              The Groundwork
            </Link>
            <Link href="/brand" className="text-left hover:text-[#1D4C74] transition-colors">
              Brand Guide
            </Link>
            <a href="#" className="hover:text-[#1D4C74] transition-colors">
              Contact
            </a>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto pt-8 border-t border-[#ECE9E0]/30 text-center md:text-left text-[9px] tracking-[0.4em] uppercase opacity-60 flex flex-col md:flex-row justify-between">
        <span>&copy; 2026 Miracle Hill Leisure Club.</span>
        <span className="mt-4 md:mt-0">Desert Hot Springs, CA</span>
      </div>
    </footer>
  );
}
